import React from 'react'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
  HeaderBarRightAction,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon-v2'

import {
  useConversationStore,
  useConversationMessageStore,
  useConversationLandingOnboardingStore,
} from 'stores/conversation'
import { useSETrackEvent } from 'app/ConversationPage/hooks/useSETrackEvent'
import { AbortRequestService } from 'app/ConversationPage/utils/api'

interface IConversationHeaderProps {
  borderless?: boolean
  showRightAction?: boolean
}
const ConversationHeader: React.FC<IConversationHeaderProps> = ({
  borderless = false,
  showRightAction = false,
}) => {
  const router = useRouter()
  const { hasConversationId, conversationId } = useConversationStore()
  const { hasMessages, setConfirmSheetOpen } = useConversationMessageStore()
  const { SETrackConversationPage } = useSETrackEvent()
  const abortController = AbortRequestService.getInstance()

  const hasConversation = hasConversationId() && hasMessages()

  const { landingOnboardingVariant } = useConversationLandingOnboardingStore()
  const isLandingOnboardingVariantC = landingOnboardingVariant === 'variant_3'

  const startNewSessionHandler = React.useCallback(() => {
    setConfirmSheetOpen(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const clickLearnMoreHandler = () => {
    SETrackConversationPage('CLICK_GURU_AI_PELAJARI_LEBIH_LANJUT', {
      ai_chat_session_id: conversationId,
      is_new_ai_chat_session: [true, 'bool'],
    })
  }

  return (
    <>
      <HeaderBar fixed borderless={borderless}>
        <HeaderBarLeftAction
          data-testid="conversation-back-button"
          icon={<Icon>close</Icon>}
          onClick={() => {
            abortController.abortRequest()
            historyUtils.backToApp(() => {
              const isNewActivity = window.history.length <= 2
              if (isNewActivity) router.push('/home')
              else router.back()
            })
          }}
        />
        <HeaderBarTitle subtitle="Beta">Asisten Guru</HeaderBarTitle>
        {showRightAction && (
          <HeaderBarRightAction type="text" className="whitespace-nowrap">
            {isLandingOnboardingVariantC || hasConversation ? (
              <button
                onClick={startNewSessionHandler}
                className={clsx(
                  'font-semibold',
                  !hasConversation && 'text-disabled'
                )}
                disabled={!hasConversation}
              >
                Mulai diskusi baru
              </button>
            ) : (
              <>
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a
                  href={`${process.env.NEXT_PUBLIC_PUSAT_INFORMASI_BASE_URL}/hc/id/sections/28896643862553-Tentang-Asisten-Guru`}
                  target="_blank"
                  onClick={clickLearnMoreHandler}
                >
                  Pelajari panduan
                </a>
              </>
            )}
          </HeaderBarRightAction>
        )}
      </HeaderBar>
    </>
  )
}

export default ConversationHeader
